// Types d'entités du modèle de lecture local et leurs correspondances.

const TERMINES = ['COMPLETED', 'CANCELLED'];

/**
 * Adresses de lecture qui montrent un sous-ensemble d'un type existant.
 * `/trips/active` lit les mêmes trajets que `/trips`: une seule vérité locale.
 */
export const ALIAS_DE_LECTURE = {
  '/trips/active': {
    kind: '/trips',
    filtre: (trajet) => !TERMINES.includes(String(trajet?.status || '').toUpperCase()),
  },
};

/** Collections du pull `/sync/full` -> type local (même nom que l'adresse de lecture). */
export const TYPE_DES_COLLECTIONS_DU_PULL = {
  trucks: '/trucks',
  drivers: '/drivers',
  companies: '/companies',
  operations: '/operations',
  trips: '/trips',
  clients: '/clients',
  orders: '/orders',
  invoices: '/invoices',
  stock_movements: '/stock',
  pricing_rules: '/pricing-rules',
  stations: '/stations',
};

export const TYPES_COUVERTS_PAR_LE_PULL = new Set(Object.values(TYPE_DES_COLLECTIONS_DU_PULL));

/** Mot de la file hors ligne (`entity_type`) -> type local. */
export const TYPE_DES_ENTITES_DE_FILE = {
  truck: '/trucks',
  driver: '/drivers',
  company: '/companies',
  operation: '/operations',
  trip: '/trips',
  client: '/clients',
  order: '/orders',
  invoice: '/invoices',
  stock_movement: '/stock',
  pricing_rule: '/pricing-rules',
  station: '/stations',
};

/** Lecture d'un type par son adresse de détail: `/orders/abc` -> `/orders`. */
export const typeDeLecture = (chemin) => ALIAS_DE_LECTURE[chemin]?.kind || chemin;

/** Libellé français du type, pour la file d'envois (jamais d'adresse brute à l'écran). */
const LIBELLES = [
  [/^\/trips\/[^/]+\/expenses/, 'Frais de trajet'],
  [/^\/trips\/[^/]+\/freight/, 'Fret du trajet'],
  [/^\/trips\/[^/]+\/(workflow|status)/, 'Étape de trajet'],
  [/^\/trips/, 'Trajet'],
  [/^\/orders\/[^/]+\/(allocate|auto-allocate|allocate-batch)/, 'Affectation de commande'],
  [/^\/orders\/[^/]+\/deliver/, 'Livraison de commande'],
  [/^\/orders/, 'Commande'],
  [/^\/stock/, 'Mouvement de stock'],
  [/^\/observations/, 'Observation'],
  [/^\/finance\/expenses|^\/charge-rules|^\/trucks\/[^/]+\/charge-rules/, 'Dépense'],
  [/^\/trucks/, 'Camion'],
  [/^\/drivers/, 'Chauffeur'],
  [/^\/clients/, 'Client'],
  [/^\/companies/, 'Transporteur'],
  [/^\/operations/, 'Convoi'],
  [/^\/maintenance\/work-orders/, 'Ordre de travail'],
  [/^\/maintenance\/breakdowns/, 'Panne'],
  [/^\/maintenance\/immobilizations/, 'Immobilisation'],
  [/^\/maintenance/, 'Entretien'],
  [/^\/invoices/, 'Brouillon de facture'],
  [/^\/documents/, 'Document'],
];

export const libelleDeRequete = (chemin) => {
  const trouve = LIBELLES.find(([motif]) => motif.test(chemin || ''));
  return trouve ? trouve[1] : 'Modification';
};
